import type { TripStatusType } from 'api/swagger';

export const isTripStarted = (tripStatus: TripStatusType): boolean => {
  return tripStatus === 'progress' || tripStatus === 'done' || tripStatus === 'ready';
};
